module.exports = __webpack_public_path__ + "static/img/qi_10.47611c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_10.jpg
// module id = mwx6
// module chunks = 1